export default __webpack_public_path__ + "static/media/undraw_mobile_app_re_catg.ce2671b0.svg";